import { useCallback, useEffect } from 'react';

import queryString from 'query-string';

import { useGetHubSpotSSOToken } from '@cobliteam/hooks/src/useEntity/useSession';

import { LoadingPage } from '../pages';

// Test in localhost, use this url:  http://localhost:3000/home?redirect_url=https://suporte.cobli.co/tickets-view
// This component is responsible for redirecting the user to the HubSpot login page.
// The redirect URL is passed as a query string parameter.
// After the user logs in, he is redirected to the URL passed in the query string.
// The URL is saved in the sessionStorage to be used after the user logs in.
const HubSpotSSORedirect = ({ children }: any) => {
  const redirectUrl = sessionStorage.getItem('ssoRedirectUrl');
  const { data: jwt } = useGetHubSpotSSOToken({ enabled: !!redirectUrl });

  const redirectToRedirectUrl = useCallback(() => {
    if (jwt) {
      sessionStorage.removeItem('ssoRedirectUrl');
      const redirectURLObject = new URL(redirectUrl || '');
      const url = redirectUrl?.includes('verify')
        ? redirectUrl
        : `${redirectURLObject.protocol}//${redirectURLObject.hostname}/_hcms/mem/jwt`;
      window.location.href = `${url}?jwt=${jwt}&redirect_url=${redirectUrl}`;
    }
  }, [jwt, redirectUrl]);

  useEffect(() => {
    if (redirectUrl) redirectToRedirectUrl();
  }, [redirectToRedirectUrl, redirectUrl]);

  if (redirectUrl) return <LoadingPage />;

  return children;
};

// Test in localhost, use this url:  http://localhost:3000/home?redirect_url=https://suporte.cobli.co/tickets-view
// This line of code stores the redirect URL in session storage.
// The redirect URL is passed as a query string parameter.
// If the redirect URL is present, it will be stored in session storage.
// If the redirect URL is not present, null will be returned.
const saveUrlToRedirectHubSpot = () => {
  const queryStringRedirectUrl = queryString.parse(window.location.search)
    .redirect_url as string;
  if (queryStringRedirectUrl)
    sessionStorage.setItem('ssoRedirectUrl', queryStringRedirectUrl);
  return null;
};

export { saveUrlToRedirectHubSpot };

export default HubSpotSSORedirect;
